import styled, { createGlobalStyle } from 'styled-components';
import React from 'react';


const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
  }
`;


const TopBorder = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background-color: #f37c3e;
    z-index: 1000;
`;

const InvisibleLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
`;

const HeroBlurb = styled.div.attrs({
  className: 'space-grotesk-header'
})`
  position: absolute;
  ${'' /* background-color: #f37c3e; */}
  top: 35%;
  left: 10%;
  color: #F0F0F0;
  font-size: 3em;
  ${'' /* font-weight: 700; */}
  text-shadow: 0 0 20px rgba(0,0,0);
  ${'' /* text-decoration: underline; */}
  ${'' /* text-decoration-thickness: 3px; */}
  ${'' /* text-decoration-color: #f37c3e; */}
  z-index: 2;
  ${'' /* max-width: 50vw; */}

  @media (max-width: 768px) {
    font-size: 1.5em;
    left: 5%;
    max-width: 90vw;
  }
`;


const HeroHeader = styled.div`
  position: relative;
  width: 100vw;
  height: 50vh;
  min-height: 200px;
  background: url('img/assets/header_bw_cropped.png') top left/cover no-repeat;
  display: flex;
  align-items: flex-start;
  overflow: hidden;

  @media (max-width: 768px) {
    background: url('img/assets/header_bw_cropped.png') top center/cover no-repeat;
  }
`;

const PageHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 10px 0 0 20px;
  z-index: 999;
`;

const Header = styled.div.attrs({
  className: 'space-grotesk-regular'
})`
  text-align: left;
  padding: 20px 10px 20px 20px;
  color: #F4F4F4;
  font-size: 2em;
  text-shadow: 0 0 20px #2c2c2c;
`

const Logo = styled.img`
  width: 60px; /* Set the width of the image */
  height: auto; /* Maintain aspect ratio */
`;

const LandingContainer = styled.div`
  display: flex; /* Use flexbox for layout */
  flex-direction: column; /* Stack children vertically */
  background: url('img/assets/collage_bg_rotated.png') center repeat;
`;

const ToolsSection = styled.section`
  flex-grow: 1; /* Allow this section to grow and push Footer to the bottom */
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0;
  gap: 24px;
  position: relative;
`;

const ToolsHeader = styled.h3`
  text-align: left;
  font-size: 2em;
  color: rgb(65, 65, 65);
  padding: 2px 4px;
  margin: 0;
  font-family: 'Space Grotesk', sans-serif;
  width: 90vw; /* Match the width of ToolCards */
  max-width: 600px; /* Match the max-width of ToolCards */
`;

const ToolCard = styled.a`
  display: block;
  width: 90vw;
  max-width: 600px;
  background: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(65, 65, 65);
  ${'' /* box-shadow: 0 4px 24px rgba(0,0,0,0.08); */}
  padding: 32px 24px;
  text-decoration: none;
  color: rgb(65, 65, 65);
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.4em;
  font-weight: 500;
  transition: box-shadow 0.2s, transform 0.2s;
`;

const StandingsCard = styled(ToolCard)`
  position: relative;
  overflow: hidden;
  background: #ffffff url('img/assets/standings_tool_card_thumb.png') right center/auto 100% no-repeat;
  height: 160px;
  &:hover, &:focus {
    transform: translateY(-2px) scale(1.01);
    outline: none;
  }
`;

const PlaceholderToolCard = styled(ToolCard)`
  position: relative; /* Enable positioning for pseudo-elements */

  &::before, &::before {
    content: ''; /* Create the additional "cards" */
    position: absolute;
    top: 4px; /* Offset for the stacking effect */
    left: 4px;
    width: 100%;
    height: 100%;
    background: #fff; /* Same background as the main card */
    border: 1px solid #606060; /* Same border as the main card */
    z-index: -1; /* Place behind the main card */
  }

  &::after {
    top: 8px; /* Additional offset for the third card */
    left: 8px;
    z-index: -2; /* Place behind the second card */
  }
`;


function Landing() {
  return (
    <>
      <LandingContainer>
        <GlobalStyle />
        <TopBorder />

        <HeroHeader>
          <PageHeader>
            <Logo src="img/assets/logo_large_orange.png" alt="Logo" />
            <Header>basketology</Header>
          </PageHeader>
          <HeroBlurb>
            Visualize the past and<br />
            present of NBA<br />
            basketball
          </HeroBlurb>
        </HeroHeader>

        <ToolsSection>
          <ToolsHeader>» tools</ToolsHeader>
          <StandingsCard href="/standings">
            <span style={{textDecoration: 'underline', textDecorationThickness: '3px', textDecorationColor: '#f37c3e'}}>Season standings</span><br />
            <span style={{fontSize: '0.7em', color: '#606060', fontWeight: 400}}>
              Explore the history of the league in-depth with interactive graphs and tables for current and past seasons.
            </span>
          </StandingsCard>
          <PlaceholderToolCard href="/">
            Coming soon...<br />
            <span style={{fontSize: '0.7em', color: '#606060', fontWeight: 400}}>
              More tools on the way
            </span>
          </PlaceholderToolCard>
        </ToolsSection>
      </LandingContainer>
    </>
  );
}

export default Landing;
